import React from 'react';
import { Modal, PrimaryButton } from '@common/components';
import { Button } from 'antd';
import { Colors } from '@common/tokens';

type Props = {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DisableAllNotificationsConfirmModal({
  visible,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <>
      <Modal
        className="account-settings__notifications-section__modal"
        title="Turning off will clean your notifications settings"
        visible={visible}
        footer={[
          <Button
            key="cancel"
            onClick={onCancel}
            style={{ borderColor: Colors.steel }}
          >
            Cancel
          </Button>,
          <PrimaryButton
            key="switch_off"
            onClick={onConfirm}
            style={{ backgroundColor: Colors.coral, borderColor: Colors.coral }}
          >
            Turn Off Notifications
          </PrimaryButton>,
        ]}
      >
        <p className="account-settings__notifications-section__modal__description">
          If you want to keep the current notifications settings, please click
          Cancel.
        </p>
      </Modal>
      <style jsx>{`
        .account-settings__notifications-section__modal__description {
          color: ${Colors.midnightLighter};
          font-weight: 350;
          font-size: 16px;
          line-height: 20px;
          margin: 0;
        }
      `}</style>
    </>
  );
}
